module.exports = __webpack_public_path__ + "static/media/annualmilad.de1f94cd.jpg";